import { Switch, Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import Card from '../../components/partials/Card';
import PageHeader from '../../components/partials/PageHeader';
import { productsData } from '../../dummyData';
import NotFound from '../NotFound';

const EditProduct = () => {
	const { productId } = useParams();

	const product = productsData.find(
		(product) => String(product.id) === productId
	);

	const breadcrumbs = [
		<Link key='1' color='inherit' to='/'>
			Dashboard
		</Link>,
		<Link key='2' color='inherit' to='/products'>
			Products
		</Link>,
		<Typography key='3' color='text.primary'>
			Edit Product: {product?.title}
		</Typography>,
	];

	return (
		<>
			{product ? (
				<>
					<PageHeader
						pageTitle={`Edit Product ${product.title}`}
						breadcrumbs={breadcrumbs}
					/>

					<Card
						title={`Edit Product: ${product.title}`}
						className='pb-5 md:w-1/2'
					>
						<form>
							<div className='grid grid-cols-1 md:grid-cols-2 gap-2'>
								<div className='my-2'>
									<label
										htmlFor='title'
										className='font-semibold text-gray-600 text-lg'
									>
										Title
									</label>
									<input
										className='form-input'
										type='text'
										id='title'
										placeholder='Type title ...'
										onChange={() => {}}
                                        value={ product.title }
									/>
								</div>
								<div className='my-2'>
									<label
										htmlFor='image'
										className='font-semibold text-gray-600 text-lg'
									>
										Image (URL)
									</label>
									<input
										className='form-input'
										type='text'
										id='image'
										placeholder='Type image ...'
										onChange={() => {}}
                                        value={ product.image }
									/>
								</div>
								<div className='my-2'>
									<label
										htmlFor='stock'
										className='font-semibold text-gray-600 text-lg'
									>
										Stock
									</label>
									<input
										className='form-input'
										type='number'
										id='stock'
										placeholder='Type stock ...'
										onChange={() => {}}
                                        value={ product.stock }
									/>
								</div>
								<div className='my-2'>
									<label
										htmlFor='price'
										className='font-semibold text-gray-600 text-lg'
									>
										Price
									</label>
									<input
										className='form-input'
										type='number'
										id='price'
										placeholder='Price ..'
										onChange={() => {}}
                                        value={ product.price }
									/>
								</div>
							</div>

							<div className='my-2'>
								<label
									htmlFor='status'
									className='font-semibold text-gray-600 text-lg'
								>
									Status
								</label>
								<div className='flex justify-between items-center'>
									<span>Product Active ?</span>
									<Switch defaultChecked={ product.status === 'active' } />
								</div>
							</div>
							<button
								type='submit'
								className='button-dark py-2 w-full text-xl'
							>
								EDIT
							</button>
						</form>
					</Card>
				</>
			) : (
				<NotFound />
			)}
		</>
	);
};

export default EditProduct;
